const retryCount = {
  MAX_RETRY_COUNT: 1,
};

class RetryAPI {
  constructor() {
    this.MAX_RETRY_COUNT = retryCount.MAX_RETRY_COUNT;
    this.retryCount = 0;
    this.RETRY_SUCCESS = false;
    this.responseReceived = false;
    this.errorCode = '';
  }

  setErrorCode(error) {
    this.errorCode = error;
  }

  getErrorCode() {
    return this.errorCode;
  }

  setResponseReceived(responseReceived) {
    this.responseReceived = responseReceived;
  }

  getResponseReceived() {
    return this.responseReceived;
  }

  incrementRetryCount() {
    this.retryCount++;
  }

  performRetry() {
    return this.retryCount < this.MAX_RETRY_COUNT;
  }

  retryFailed() {
    return this.retryCount >= this.MAX_RETRY_COUNT;
  }

  resetRetryCount() {
    this.retryCount = 0;
  }

  resetRetryAPI() {
    this.retryCount = 0;
    this.RETRY_SUCCESS = false;
    this.responseReceived = false;
    this.errorCode = '';
  }
}

export default new RetryAPI();
